import { bludgeoning } from "./bludgeoning";
import { piercing } from "./piercing";
import { slashing } from "./slashing";

export const physical = {
  bludgeoning,
  piercing,
  slashing,
};
